/* eslint-disable import/no-anonymous-default-export */
import profileRepository from '../repositories/profileRepository'
import { useLocation } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../store/hooks'
import { authCreators } from '../store/ducks/auth'
import companyRepository from '../repositories/companyRepository'

let profileDidInit = false
const blockedRoutes = ['/sair']

function useGetProfile() {
	const { pathname } = useLocation()
	const dispatch = useAppDispatch()

	const { signed } = useAppSelector((state) => state.auth)

	const { data, isLoading, isSuccess, isFetching, isError, refetch } =
		profileRepository.useGetQuery(undefined, {
			skip: !signed || blockedRoutes.includes(pathname),
			refetchOnMountOrArgChange: true,
		})

	if (!profileDidInit && data) {
		profileDidInit = true
		dispatch(authCreators.setUser(data))
		dispatch(companyRepository.util.invalidateTags(['Company']))
	}

	return { data, isLoading, isSuccess, isFetching, isError, refetch }
}

function useGetProfileMutation() {
	const { pathname } = useLocation()
	const dispatch = useAppDispatch()

	const [_getProfile, { data, isLoading, isSuccess, isError }] =
		profileRepository.useGetMutationMutation()

	async function execute() {
		try {
			await _getProfile()

			if (!profileDidInit && !blockedRoutes.includes(pathname) && data) {
				profileDidInit = true
				dispatch(authCreators.setUser(data))
				dispatch(companyRepository.util.invalidateTags(['Company']))
			}
		} catch (error) {
			console.error(error)
		}
	}

	return { execute, data, isLoading, isSuccess, isError }
}

function useEditMutation() {
	const {
		auth: { user },
	} = useAppSelector((state) => state)

	const [_editProfile, { data, isLoading, isSuccess, isError }] =
		profileRepository.useEditMutationMutation()

	async function execute(body: {
		curso_id?: number | null
		telephone?: string
		leveling_event_id?: string
		show_modal_progress_check?: boolean
		show_modal_calendar?: boolean
		show_modal_skill_mapping?: boolean
	}) {
		try {
			if (!user?.id) return

			await _editProfile({ id: user.id, ...body })
		} catch (error) {
			console.error(error)
		}
	}

	return { execute, data, isLoading, isSuccess, isError }
}

function useSaveGoogleCalendarMutation() {
	const {
		auth: { user },
	} = useAppSelector((state) => state)

	const [_saveGoogleCalendar, { data, isLoading, isSuccess, isError }] =
		profileRepository.useSaveGoogleCalendarMutationMutation()

	async function execute(body: {
		calendario_code?: string
		calendario_refresh_token?: string
		calendario_email?: string
	}) {
		try {
			if (!user?.id) return

			await _saveGoogleCalendar({ id: user.id, ...body })
		} catch (error) {
			console.error(error)
		}
	}

	return { execute, data, isLoading, isSuccess, isError }
}

export default {
	getProfile: useGetProfile,
	getProfileMutation: useGetProfileMutation,
	editMutation: useEditMutation,
	saveGoogleCalendarMutation: useSaveGoogleCalendarMutation,
}
